class Localize {
  static exps = null;
  static chassis = null;
  static models = null;

  static LE = (key) => {
    Localize.exps = Localize.exps || (window.site_config || {}).localization || [];
    return (Localize.exps.find(f => f.key === key) || { value: key }).value;
  }

  static LM = (key, data) => {
    Localize.models = Localize.models || (window.site_config || {}).models || [];
    let loc = (Localize.models.find(f => f.key.toUpperCase() === key.toUpperCase() && (data.ManufacturerName ? data.ManufacturerName.toUpperCase() == f.manufacturer_name.toUpperCase() : true)) || { key: key, value: key });
    return loc.value != "" ? loc.value : loc.key;
  }

  static LC = (key, data) => {
    Localize.chassis = Localize.chassis || (window.site_config || {}).chassis || [];
    let loc = (Localize.chassis.find(f => f.key.toUpperCase() === key.toUpperCase() && (data.ManufacturerName ? data.ManufacturerName.toUpperCase() == f.manufacturer_name.toUpperCase() : true)) || { key: key, value: key });
    return loc.value != "" ? loc.value : loc.key;
  }

  static L = (key, data) => {
    if (typeof data === "undefined" || !data.Get) {
      return Localize.LE(key);
    } else if (data.Get === "models") {
      return Localize.LM(key, data);
    } else if (data.Get === "chassis") {
      return Localize.LC(key, data);
    }
  }
}

export { Localize };